import style from "./index.module.css";

export const SeparatorIcon = () => <div className={style.separator}></div>;
